<template>
  <Start />
</template>
<script route="/set_up_shop/apply">
  import Start from './index'
  export default {
    components: {Start}
  }
</script>
